import { TSetCommonItemFn, TGetCommonItemFn, TRemoveCommonItemFn } from './types'

export const buildKey = (key: string, prefix?: string | null | undefined) => {
  let _key = key
  if (prefix) {
    _key = `${prefix}--${_key}`
  }
  return _key
}

export const setCommonItem: TSetCommonItemFn = (key, value, prefix) => {
  const _key = buildKey(key, prefix)
  return localStorage.setItem(_key, <string>value)
}

export const getCommonItem: TGetCommonItemFn = (
  key: string,
  prefix?: string | null | undefined
) => {
  const _key = buildKey(key, prefix)
  return localStorage.getItem(_key)
}

export const removeCommonItem: TRemoveCommonItemFn = (
  key: string,
  prefix?: string | null | undefined
) => {
  const _key = buildKey(key, prefix)
  return localStorage.removeItem(_key)
}
